import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/styles';
import placeholder_illustration from 'assets/img/placeholder_illustration.png';
import AlertDialogSlide from 'common/components/dialog/dialog';
import GeneralGrid from 'common/components/layout/grid/GeneralGrid';
import LoadingProgress from 'common/components/progress/loading';
import styles from 'material-dashboard-assets/jss/material-dashboard-react/views/dashboardStyle.js';
import Card from 'material-dashboard-components/Card/Card.js';
import CardFooter from 'material-dashboard-components/Card/CardFooter.js';
import CardHeader from 'material-dashboard-components/Card/CardHeader.js';
import CardIcon from 'material-dashboard-components/Card/CardIcon.js';
import GridContainer from 'material-dashboard-components/Grid/GridContainer.js';
import GridItem from 'material-dashboard-components/Grid/GridItem.js';
import { getActionResults } from 'modules/owner/pages/actions/activeActions/activeActionsScripts.js';
import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Typography } from '@material-ui/core';
import { ColumnsBelowSearch, NumberGenericElement } from 'common/components/table/tableComponents';
import Table from 'common/components/table/table-material';
import {
  getProductAction,
  startUnusedVoucherCodesExport,
  getUnusedVoucherCodesExportStatus,
  downloadUnusedVoucherCodesExport,
} from 'modules/owner/pages/sales/productOrders/productOrdersActions.js';
import * as XLSX from 'xlsx';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import { getListall } from '../../validators/validatorsActions.js';
import { toastr } from 'react-redux-toastr';
import { csvRow } from 'helpers/csv';
const { format } = require('date-fns');

const EXPORT_POLL_INTERVAL_MS = 2000;
const EXPORT_POLL_MAX_ATTEMPTS = 90;

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exportingUnusedCodes: false,
    };
    this.exportPollTimeout = null;
    this.props.getActionResults(this.props.location.query.action);
    this.props.getProductAction(this.props.location.query.action);
    this.props.getListall(this.props.auth.user.establishments[0].stations[0].id);
  }

  componentWillUnmount() {
    if (this.exportPollTimeout) {
      clearTimeout(this.exportPollTimeout);
    }
  }

  Validador = (validador, code) => {
    for (let b = 0; b < validador.length; b++) {
      if (code === validador[b].id) {
        return validador[b].identification;
      }
    }
    return ' ';
  };

  onDialogClose = () => {
    if (this.props.location.query.from === 'inicio') {
      this.props.router.push('/owner/acoes/inicio');
    } else if (this.props.location.query.from === 'contacts') {
      this.props.router.push('/owner/contacts');
    } else {
      this.props.router.push(
        `/owner/acoes/minhas-atividades/?to=${this.props.location.query.from}`
      );
    }
  };

  converterParaCSV = (listaDeInformacao) => {
    let j = 0;
    let contador = 0;
    if (!Array.isArray(listaDeInformacao) || listaDeInformacao.length === 0) {
      console.error('Lista de objetos vazia ou inválida.');
      return '';
    }
    // Obtém os cabeçalhos do CSV a partir das chaves selecionadas
    const cabe = [
      'Nome',
      'CPF',
      'Telefone',
      'E-mail',
      'Local de entrega',
      'Endereço',
      'CEP',
      'Referência',
      'Código',
      'Produto',
      'Quantidade',
      'Valor',
      'Data da compra',
      'Status',
    ];
    const question = listaDeInformacao[0]?.user?.answers;
    if (question) {
      for (let i = 0; i < question.length; i++) {
        cabe.push(question[i].question.question);
      }
    }
    // Gera as linhas do CSV
    const linhas = [];
    for (let i = 0; i < listaDeInformacao.length; i++) {
      const product = listaDeInformacao[i];
      // Validação para evitar erros com dados nulos ou inválidos
      if (product && product.single_product_orders && product.user) {
        for (let a = 0; a < product.single_product_orders.length; a++) {
          const spo = product.single_product_orders[a];
          // Validação para evitar erro se product for nulo
          if (spo && spo.product) {
            const updatedat = new Date(product.updatedAt);
            const produto = spo.product?.name || 'N/A';
            const userName = product.user?.name || 'N/A';

            linhas[`${j}`] = [];
            linhas[j].push((userName || 'N/A').replace(/,/g, '.'));
            linhas[j].push(product.user?.cpf ?? ' ');
            linhas[j].push(product.user?.tel ?? ' ');
            linhas[j].push(product.user?.email ?? ' ');
            linhas[j].push(product.delivery_location?.name ?? ' ');
            linhas[j].push(product.address === null ? ' ' : product.address.replace(/,/g, '.'));
            linhas[j].push(product.zipcode === null ? ' ' : product.zipcode);
            linhas[j].push(product.reference === null ? ' ' : product.reference.replace(/,/g, '.'));
            linhas[j].push(product.code ?? ' ');
            linhas[j].push((produto || 'N/A').replace(/,/g, '.'));
            linhas[j].push(1);
            linhas[j].push(spo.product?.value ?? ' ');
            linhas[j].push(format(updatedat, 'dd/MM/yyyy HH:mm:ss'));
            linhas[j].push(product.status ?? ' ');
            if (question) {
              const answer = product.user.answers;
              for (let b = 0; b < answer.length; b++) {
                linhas[j].push(answer[b]?.answer ?? ' ');
              }
            }
            j++;
          }
        }
      }
    }
    linhas[`${j}`] = [];
    const linhasCSV = linhas.map((linha) => csvRow(linha));
    const csv = [csvRow(cabe), ...linhasCSV].join('\n');
    return csv;
  };

  converterCSV = (listaDeInformacao, validador) => {
    let j = 0;
    let contador = 0;
    if (!Array.isArray(listaDeInformacao) || listaDeInformacao.length === 0) {
      console.error('Lista de objetos vazia ou inválida.');
      return '';
    }
    // Obtém os cabeçalhos do CSV a partir das chaves selecionadas
    const cabe = [
      'Nome',
      'Entidade',
      'CPF',
      'Telefone',
      'Voucher',
      'Emissão',
      'Validador',
      'Validação',
    ];

    // Gera as linhas do CSV
    const linhas = [];
    for (let i = 0; i < listaDeInformacao.length; i++) {
      const user = listaDeInformacao[i];
      for (let a = 0; a < user.presential_course_subscriptions.length; a++) {
        const pcs = user.presential_course_subscriptions[a];
        const createdat = new Date(pcs.createdAt);
        const validation_date = new Date(pcs.validation_date);

        linhas[`${j}`] = [];
        linhas[j].push(user.name);
        linhas[j].push(user.station_name || pcs.presential_course?.action?.station?.name || '');
        linhas[j].push(user.cpf);
        linhas[j].push(user.tel);
        linhas[j].push(pcs.code);
        linhas[j].push(format(createdat, 'dd/MM/yyyy HH:mm:ss'));
        linhas[j].push(this.Validador(validador, pcs.code_validator_id));
        if (pcs.validated === '1') {
          linhas[j].push(format(validation_date, 'dd/MM/yyyy HH:mm:ss'));
          contador++;
        } else {
          linhas[j].push(pcs.validation_date);
        }
        j++;
      }
    }
    linhas[`${j}`] = [];
    linhas[j].push(contador);
    const linhasCSV = linhas.map((linha) => csvRow(linha));
    const csv = [csvRow(cabe), ...linhasCSV].join('\n');

    return csv;
  };

  gerarExcel = (csvString, titulo, actionName = '') => {
    try {
      const nomeAtividade =
        titulo[0]?.presential_course_subscriptions[0]?.presential_course?.action?.name ||
        actionName;
      const dataAtual = new Date();
      const dia = dataAtual.getDate();
      const mes = dataAtual.getMonth() + 1; // Adicione 1 porque os meses começam do zero
      const ano = dataAtual.getFullYear();
      // O CSV já vem com aspas e escapes: `XLSX.read` entende o formato, e o
      // `split(',')` de antes partia em duas colunas toda célula com vírgula.
      const lido = XLSX.read(csvString, { type: 'string', raw: true });
      const worksheet = lido.Sheets[lido.SheetNames[0]];
      // Crie um workbook do Excel
      const workbook = XLSX.utils.book_new();
      // Adicione a planilha ao workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
      // Salve o workbook como um arquivo Excel
      XLSX.writeFile(workbook, `relatorio_${nomeAtividade}_${dia}_${mes}_${ano}.xlsx`);
    } catch (error) {
      toastr.error('Erro', 'Não foi possível exportar o relatório.');
      console.error('Não foi possível gerar o relatório.', error);
    }
  };

  triggerFileDownload = (blobOrUrl, fileName) => {
    const isUrl = typeof blobOrUrl === 'string';
    const href = isUrl ? blobOrUrl : window.URL.createObjectURL(blobOrUrl);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName || 'codigos_nao_usados.csv');
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    link.remove();
    if (!isUrl) {
      window.URL.revokeObjectURL(href);
    }
  };

  pollUnusedVoucherCodesExport = async (jobId, attempt = 0) => {
    if (attempt >= EXPORT_POLL_MAX_ATTEMPTS) {
      toastr.error('Erro', 'Tempo esgotado ao gerar a planilha. Tente novamente.');
      this.setState({ exportingUnusedCodes: false });
      return;
    }

    try {
      const { data } = await getUnusedVoucherCodesExportStatus(jobId);
      const { status, downloadUrl, fileName, message } = data;

      if (status === 'pending' || status === 'processing') {
        this.exportPollTimeout = setTimeout(
          () => this.pollUnusedVoucherCodesExport(jobId, attempt + 1),
          EXPORT_POLL_INTERVAL_MS
        );
        return;
      }

      if (status === 'empty') {
        toastr.warning('Aviso', message || 'Não há códigos não utilizados para exportar.');
        this.setState({ exportingUnusedCodes: false });
        return;
      }

      if (status === 'error') {
        toastr.error('Erro', message || 'Não foi possível exportar os códigos não utilizados.');
        this.setState({ exportingUnusedCodes: false });
        return;
      }

      if (status === 'ready' && downloadUrl) {
        const response = await downloadUnusedVoucherCodesExport(
          downloadUrl,
          Boolean(data.requiresAuth)
        );

        if (response.url) {
          this.triggerFileDownload(response.url, fileName);
        } else if (response.data) {
          this.triggerFileDownload(response.data, fileName || 'codigos_nao_usados.csv');
        }

        toastr.success('Sucesso', 'Planilha gerada com sucesso.');
        this.setState({ exportingUnusedCodes: false });
        return;
      }

      toastr.error('Erro', 'Resposta inesperada ao consultar a exportação.');
      this.setState({ exportingUnusedCodes: false });
    } catch (error) {
      toastr.error('Erro', 'Não foi possível consultar o status da exportação.');
      console.error('Erro ao consultar status da exportação:', error);
      this.setState({ exportingUnusedCodes: false });
    }
  };

  exportUnusedVoucherCodes = async () => {
    const actionId = this.props.location.query.action;

    this.setState({ exportingUnusedCodes: true });

    try {
      const { data } = await startUnusedVoucherCodesExport(actionId);
      if (!data?.jobId) {
        throw new Error('JobId não retornado');
      }
      this.pollUnusedVoucherCodesExport(data.jobId);
    } catch (error) {
      toastr.error('Erro', 'Não foi possível iniciar a exportação dos códigos.');
      console.error('Erro ao iniciar exportação de códigos não utilizados:', error);
      this.setState({ exportingUnusedCodes: false });
    }
  };

  renderEmptyScreen() {
    return (
      <AlertDialogSlide
        title="Resultados"
        visible={true}
        height="95vh"
        onClose={this.onDialogClose}
        maxWidth={isMobile ? 'xl' : 'sm'}>
        <section id="statement-buy-points" style={{ height: '100vh' }}>
          <GeneralGrid container spacing={3} alignItems="center">
            <GeneralGrid item xs={12} md={6}>
              <GeneralGrid container spacing={3}>
                <GeneralGrid item xs={12}>
                  <h2 className="signup-text">Ninguém participou dessa atividade até o momento</h2>
                  <p>Aqui você poderá distribuir os prêmios</p>
                </GeneralGrid>
              </GeneralGrid>
            </GeneralGrid>
            <GeneralGrid item xs={12} md={6}>
              <img alt="" src={placeholder_illustration} className="img-fluid" />
            </GeneralGrid>
          </GeneralGrid>
        </section>
      </AlertDialogSlide>
    );
  }

  renderBackground = () => {
    return '#3f51b5';
  };

  render() {
    const { classes } = this.props;
    const { actionResults, loadingActionResults, actionDetail } = this.props.activeActions;
    const { impressions, reach, participations, cashback, cashback_left, usersReached } =
      actionResults;
    const { exportingUnusedCodes } = this.state;
    // Validação segura para evitar erro null reference
    const productOrdersData = this.props?.productOrders?.loading?.data || [];
    const CSVprint = this.converterParaCSV(productOrdersData);
    const validador = this.props?.validatorCode?.list?.content || [];
    const CSVprintVouchers = this.converterCSV(usersReached, validador);
    if (loadingActionResults) {
      return (
        <AlertDialogSlide
          title="Resultados"
          visible={true}
          height="95vh"
          onClose={this.onDialogClose}
          maxWidth={isMobile ? 'xl' : 'md'}>
          <div className="d-flex justify-content-center mt-5">
            <LoadingProgress />
          </div>
        </AlertDialogSlide>
      );
    }

    return (
      <AlertDialogSlide
        isFullScreen={isMobile}
        title={`${actionDetail.name}`}
        visible={true}
        height="95vh"
        onClose={this.onDialogClose}
        maxWidth={isMobile ? 'xl' : 'md'}>
        <Typography variant="h6">Resultados gerais</Typography>
        <GridContainer>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">remove_red_eye</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Impressões</p>
                <h3 className={classes.cardTitle}>{impressions}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a quantidade de visualizações que sua atividade teve, independente se for do mesmo usuário ou de usuários diferentes."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">people_alt</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Alcance</p>
                <h3 className={classes.cardTitle}>{reach}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a quantidade de participantes que viram sua atividade."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">call_made</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Participações</p>
                <h3 className={classes.cardTitle}>{participations.length}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a quantidade de participações efetivas na sua atividade."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">bar_chart</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Conversão</p>
                <h3 className={classes.cardTitle}>
                  {participations.length > 0
                    ? parseFloat((participations.length / reach) * 100).toFixed(1)
                    : 0}
                  %
                </h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="É a porcentagem de pessoas que participaram dessa atividade em relação a todas que foram alcançadas"
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">attach_money</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Gasto atual</p>
                <h3 className={classes.cardTitle}>R${parseFloat(cashback).toFixed(2)}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="Essa é quantidade de dinheiro que já foi paga em cashback."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4}>
            <Card style={{ position: 'relative' }} className="active-actions">
              <CardHeader color="warning" stats icon>
                <CardIcon color="white">
                  <Icon color="primary">money</Icon>
                </CardIcon>
                <p className={classes.cardCategory}>Cashback restante</p>
                <h3 className={classes.cardTitle}>R${parseFloat(cashback_left).toFixed(2)}</h3>
              </CardHeader>
              <CardFooter stats style={{ position: 'absolute', bottom: 5, width: '90%' }}>
                <div className={classes.stats} style={{ cursor: 'pointer' }}>
                  <Tooltip
                    style={{ marginLeft: 10 }}
                    title="Essa é a quantidade de dinheiro que foi reservada para ação mas ainda não foi distribuida em cashback."
                    placement="top-start">
                    <Icon color="default">help</Icon>
                  </Tooltip>
                </div>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
        <GeneralGrid container spacing={3}>
          <GeneralGrid item xs={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              {!_.isEmpty(usersReached) && (
                <>
                  {/* Botão 1 (Verde) */}
                  <div>
                    <button
                      onClick={() => this.gerarExcel(CSVprint, usersReached, actionDetail.name)}
                      aria-label="Gerar Excel">
                      <FontAwesomeIcon icon={faBook} style={{ color: 'green', fontSize: '25px' }} />
                    </button>
                  </div>

                  {/* Botão 2 (Azul) */}
                  <div>
                    <button
                      onClick={() =>
                        this.gerarExcel(CSVprintVouchers, usersReached, actionDetail.name)
                      }
                      aria-label="Gerar Excel">
                      <FontAwesomeIcon icon={faBook} style={{ color: 'blue', fontSize: '25px' }} />
                    </button>
                  </div>
                </>
              )}

              {/* Botão 3 (Roxo) - Códigos importados não utilizados */}
              {actionDetail.sell_vouchers_code && (
                <div>
                  <Tooltip title="Exportar códigos de cinema não utilizados" placement="top">
                    <button
                      onClick={this.exportUnusedVoucherCodes}
                      disabled={exportingUnusedCodes}
                      aria-label="Exportar códigos não utilizados">
                      <FontAwesomeIcon
                        icon={faBook}
                        style={{
                          color: exportingUnusedCodes ? 'gray' : 'purple',
                          fontSize: '25px',
                        }}
                      />
                    </button>
                  </Tooltip>
                </div>
              )}
            </div>
            <Table
              hasToolBar={false}
              buttonCSV
              csvData={CSVprint}
              defaultSelected={''}
              title="Extrato"
              columns={[
                { field: 'name', title: 'Nome' },
                {
                  field: 'station_name',
                  title: 'Entidade',
                  render: (rowData) => rowData.station_name || '-',
                },
                {
                  field: 'quantity',
                  title: 'Visualizações',
                  render: (rowData) => (
                    <NumberGenericElement category="visualizations" value={rowData.quantity} />
                  ),
                },
                {
                  title: 'Participação',
                  render: (rowData) =>
                    rowData.user_actions.length > 0 ? 'Visualizou e pagou' : 'Visualizou',
                },
                {
                  title: 'Email',
                  field: 'email',
                },
                {
                  title: 'Search',
                  field: 'search',
                  render: (rowData) => (
                    <ColumnsBelowSearch
                      buttons={{
                        namedButtons: [
                          {
                            name: rowData.user_actions.length > 0 ? '-' : 'Ainda não participou',
                            onClick: () => {},
                            disabled: true,
                          },
                        ],
                        iconButtons: [],
                      }}
                    />
                  ),
                },
              ]}
              rows={usersReached}
              onChangeOption={() => {}}
              selectOptions={[]}
            />
          </GeneralGrid>
        </GeneralGrid>
      </AlertDialogSlide>
    );
  }
}

Results.propTypes = {
  getProductAction: PropTypes.func.isRequired,
  activeActions: PropTypes.shape({
    actionResults: PropTypes.shape({
      cashback: PropTypes.any,
      cashback_left: PropTypes.any,
      impressions: PropTypes.any,
      participations: PropTypes.shape({
        length: PropTypes.number,
      }),
      reach: PropTypes.any,
      usersReached: PropTypes.any,
    }),
    loadingActionResults: PropTypes.any,
    actionDetail: PropTypes.shape({
      end: PropTypes.any,
      name: PropTypes.any,
      start: PropTypes.any,
    }),
  }),
  classes: PropTypes.shape({
    cardCategory: PropTypes.any,
    cardTitle: PropTypes.any,
    stats: PropTypes.any,
  }),
  getActionResults: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({
      action: PropTypes.any,
      from: PropTypes.string,
    }),
  }),
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    activeActions: state.activeActions,
    productOrders: state.productOrders,
    validatorCode: state.validatorCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getActionResults,
      getProductAction,
      getListall,
    },
    dispatch
  );
};

const StyledResults = withStyles(styles)(Results);

export default connect(mapStateToProps, mapDispatchToProps)(StyledResults);
